import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const cryptoCoinsHeaders = {
  "X-RapidAPI-Key": "e7df2cc4f2mshbd4ceadd0fee61ap12a7c9jsnc3dddb3e0058",
  "X-RapidAPI-Host": "coinranking1.p.rapidapi.com",
};
const baseUrl = "https://coinranking1.p.rapidapi.com";

const createRequest = (url) => ({ url, headers: cryptoCoinsHeaders });

export const cryptoCoin = createApi({
  reducerPath: "cryptoCoin",
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getCryptosCoins: builder.query({
      query: (count) => createRequest(`/coins?limit=${count}`),
    }),
    getCryptosDetails: builder.query({
      query: (coinId) => createRequest(`/coin/${coinId}`),
    }),
    getCryptosHistory: builder.query({
      query: ({ coinId, timePeriod }) =>
        createRequest(`/coin/${coinId}/history?timePeriod=${timePeriod}`),
    }),
    getExchanges: builder.query({
      query: () => createRequest("coin/Qwsogvtv82FCd/exchanges"),
    }),
  }),
});

export const {
  useGetCryptosCoinsQuery,
  useGetCryptosDetailsQuery,
  useGetCryptosHistoryQuery,
  useGetExchangesQuery,
} = cryptoCoin;

//coin/Qwsogvtv82FCd/exchanges
